import { Link } from "react-router-dom";
import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import NutradSPIcon from "../../assets/img/nt logo smart pipe.png";

// bootstrap
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import GridCards from "../GridCards/GridCard";
import Footer from "../Footer/Footer";
import Dashboard from "../Dashboard/Dashboard";
import QuickDropzone from "../Import/QuickDropzone";

export default function Example() {
  // Get dashboard visibility preference from localStorage
  const [showDashboard, setShowDashboard] = useState(() => {
    const savedPreference = localStorage.getItem('showDashboard');
    // If no preference is saved, default to true (show dashboard)
    return savedPreference === null ? true : JSON.parse(savedPreference);
  });

  // Force re-render when QuickDropzone preference changes
  const [quickDropKey, setQuickDropKey] = useState(0);
  
  // Update state if localStorage changes (e.g., from another tab)
  useEffect(() => {
    const handleStorageChange = () => {
      const savedPreference = localStorage.getItem('showDashboard');
      if (savedPreference !== null) {
        setShowDashboard(JSON.parse(savedPreference));
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Listen for QuickDropzone toggle changes
  useEffect(() => {
    const handleQuickDropToggle = () => {
      setQuickDropKey(prev => prev + 1); // Force re-render of QuickDropzone
    };

    window.addEventListener('quickDropToggle', handleQuickDropToggle);
    return () => {
      window.removeEventListener('quickDropToggle', handleQuickDropToggle);
    };
  }, []);
  
  return (
    <div className="bg-white">
      <main>
        <QuickDropzone key={quickDropKey} />
        {showDashboard && <Dashboard />}
        <GridCards />
      </main>
      <Footer />
    </div>
  );
}
